import { render, staticRenderFns } from "./playerDistributePie.vue?vue&type=template&id=1a9f5696&scoped=true"
import script from "./playerDistributePie.vue?vue&type=script&lang=js"
export * from "./playerDistributePie.vue?vue&type=script&lang=js"
import style0 from "./playerDistributePie.vue?vue&type=style&index=0&id=1a9f5696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9f5696",
  null
  
)

export default component.exports